module.exports = __webpack_public_path__ + "d581d639b5dc678ea11818065f018b97.png";